<template>
  <div class="selection">
    <div class="selection-top">
      <div class="selection-arrow" @click="onClickBack"><a-icon v-if="isShowArrow"  type="arrow-left" /></div>
      <span>{{title}}</span>
      <div class="click-btn" v-if="rightBtnVisible" @click="onClickBtn">{{isLast ? $t('actionTitles.finish') : $t('actionTitles.next')}}</div>
      <div style="width: 60px;" v-else></div>
    </div>
    <div class="selection-bottom" :style="{display: displayType}">
      <slot name="body"></slot>
    </div> 
  </div>
</template>

<script>
export default {
  props: {
    title: {type: String, default(){
      return this.$t('edit.editMessage.selectDefault')
    }},
    isShowArrow: {type: Boolean, default: false},
    isLast: {type: Boolean, default:false},
    rightBtnVisible: {type: Boolean, default: true},
    displayType: {type: String, default: "flex"}
  },
  methods: {
    onClickBtn() {
      if(this.isLast) {
        this.$emit("onClickFinish")
      } else {
        this.$emit("onClickNext")
      }
    },
    onClickBack() {
      this.$emit("clickBack")
    }
  }
};
</script>

<style lang="less" scoped>
// .selection {
//   /*padding: 5px 10px;*/
//     .selection-top {
//       /*padding-bottom: 10px;*/
//       padding: 0 10px 10px 10px;
//       display: flex;
//       border-bottom: 1px solid rgba(0,0,0,.1);
//       box-shadow: 0 1px 1px 0 rgba(255,255,255,.05);
//       align-items: center;
//       justify-content: space-between;
//       .selection-arrow {
//         width: 70px;
//         height: 25px;
//         line-height: 25px;
//       }
//       .click-btn {
//         height: 25px;
//         line-height: 25px;
//         padding: 2px 10px;
//         border-radius: 2px;
//         color: rgba(48, 48, 48, 1);
//         background-color: rgba(255, 255, 255, 1);
//       }
//     }
//     .selection-bottom {
//       /*border-top: 1px solid rgba(255,255,255,.04);*/
//       padding: 10px 10px 0 10px;
//       width: 100%;
//       overflow-y: auto;
//     }
//   }
</style>